module.exports = __webpack_public_path__ + "img/logo5.bd9a512a.png";